import clsx from 'clsx'
import { BinanceIcon } from './icons/BinanceIcon'
import { CoinbaseIcon } from './icons/CoinbaseIcon'
import { MetaMaskIcon } from './icons/MetaMaskIcon'

interface WalletIconsStackProps {
  className?: string
  shouldShowWeb3Wallets?: boolean
}

export const WalletIconsStack = ({
  className,
  shouldShowWeb3Wallets = true,
}: WalletIconsStackProps) => {
  return (
    <div className={clsx('flex items-center', className)}>
      <CoinbaseIcon />
      <div className="-ml-[6px]">
        <BinanceIcon />
      </div>
      {shouldShowWeb3Wallets && (
        <div className="-ml-[6px]">
          <MetaMaskIcon />
        </div>
      )}
    </div>
  )
}
